import React, { FC } from "react";
import {translate} from "../../utils/functions";
import {FormField} from "../../types/enums";

type Props = {
    selectedFields: FormField[];
    onToggleField: (field: FormField) => void;
    availableFields: FormField[];
    idPrefix?: string;
};

export const FormFieldCheckboxes: FC<Props> = ({selectedFields, onToggleField, availableFields, idPrefix = "form-field"}) => {
    return (
        <div className="grid grid-cols-1 gap-2">
            {availableFields.map((field, index) => {
                const isChecked = selectedFields.includes(field);
                const fieldId = `${idPrefix}-${index}`;
                return (
                    <div key={field} className="flex items-center">
                        <input
                            type="checkbox"
                            id={fieldId}
                            checked={isChecked}
                            onChange={() => onToggleField(field)}
                            className="mr-2"
                        />
                        <label htmlFor={fieldId} className="font-normal">
                            {translate(field)}
                        </label>
                    </div>
                );
            })}
        </div>
    );
};
